import type { ContentLocale } from '@/data/public-catalog'

export const laboratoryEquipmentProducts = {
  'prd-celle-frigorifere': {
    key: 'coldRooms',
    primaryMedia: '/media/source/images/celle-1.png',
    sourceLocale: 'it',
    supportingMedia: ['/media/source/images/MRC-2.png', '/media/source/images/MFC-2.png'],
  },
  'prd-centrifuga-centric-cf-108r-gr': {
    key: 'cf108',
    primaryMedia: '/media/source/images/centric-108-R-GR-1.png',
    sourceLocale: 'it',
    supportingMedia: ['/media/source/images/centric-108-R-GR-1.png', '/media/source/images/centric-108-R-1.png', '/media/source/images/centric-108-GR-1.png'],
  },
  'prd-centrifuga-domel-centric-350': {
    key: 'centric350',
    primaryMedia: '/media/source/images/centrifuga-350-1.png',
    sourceLocale: 'it',
    supportingMedia: ['/media/source/images/350-tabella.png'],
  },
  'prd-centrifuga-mf48-48r-domel': {
    key: 'mf48',
    primaryMedia: '/media/source/images/centrifuga-MF48-48R.png',
    sourceLocale: null,
    supportingMedia: ['/media/source/images/48-48R-tabella.png'],
  },
  'prd-congelatori-da-laboratorio': {
    key: 'freezers',
    primaryMedia: '/media/source/images/congelatori-da-laboratorio.png',
    sourceLocale: 'it',
    supportingMedia: [
      '/media/source/images/LFG-2.png',
      '/media/source/images/LF-2.png',
      '/media/source/images/LDF-1.png',
      '/media/source/images/PDF-1.png',
      '/media/source/images/ULF-2.png',
      '/media/source/images/BLCF-3.png',
      '/media/source/images/LCDF-2.png',
      '/media/source/images/LCSDF-1.png',
      '/media/source/images/ULCF-1.png',
    ],
  },
  'prd-frigoemoteche-congelatori': {
    key: 'bloodBankStorage',
    primaryMedia: '/media/source/images/frigoemoteche-1.png',
    sourceLocale: 'it',
    supportingMedia: [
      '/media/source/images/BBRV-3.png',
      '/media/source/images/LFG-MD-1.png',
      '/media/source/images/LF-MD.png',
      '/media/source/images/LDF-MD-1.png',
      '/media/source/images/PDF-MD-1.png',
    ],
  },
  'prd-frigoriferi-congelatori-portatili': {
    key: 'portableColdChain',
    primaryMedia: '/media/source/images/frigoriferi-portatili-1.png',
    sourceLocale: 'it',
    supportingMedia: [
      '/media/source/images/PRF-1.png',
      '/media/source/images/IC-2.png',
      '/media/source/images/EPRF-C-1.png',
      '/media/source/images/EPRF-HC-1.png',
    ],
  },
  'prd-frigoriferi-medicali': {
    key: 'medicalRefrigerators',
    primaryMedia: '/media/source/images/frigoriferi-medicali-evermed-1.png',
    sourceLocale: 'it',
    supportingMedia: ['/media/source/images/MPR-2.png', '/media/source/images/LR-3.png'],
  },
  'prd-frigoriferi-medicali-a-due-temperature': {
    key: 'dualTemperature',
    primaryMedia: '/media/source/images/frigoriferi-combinati-1.png',
    sourceLocale: 'it',
    supportingMedia: [
      '/media/source/images/LCRR-2.png',
      '/media/source/images/MPRR-2.png',
      '/media/source/images/LCRF-1.png',
    ],
  },
} as const

export type LaboratoryEquipmentProductId = keyof typeof laboratoryEquipmentProducts
export type LaboratoryEquipmentProductKey = (typeof laboratoryEquipmentProducts)[LaboratoryEquipmentProductId]['key']

export function isLaboratoryEquipmentProductId(id: string): id is LaboratoryEquipmentProductId {
  return id in laboratoryEquipmentProducts
}

export function laboratoryEquipmentSourceLocale(id: LaboratoryEquipmentProductId, language: ContentLocale): ContentLocale {
  return laboratoryEquipmentProducts[id].sourceLocale ?? language
}
